import { uistore } from '../store/uistore'
import { action } from 'mobx'
import debounce from 'lodash/debounce'

export default debounce(
  action((title, message, intent = 'danger', timeout, toastId) => {
    if (message && message.cause) message = message.cause
    if (uistore) uistore.toastError = { title, message, intent, timeout, toastId }
  }), 1000, { leading: true, trailing: false }
)
